<template lang="pug">
  validation-observer(
    v-slot="{ invalid, validate }"
  )
    .d-flex.flex-column.gap-24
      v-item-group(
        v-model="options"
        multiple
      )
        .d-flex.flex-column.gap-16
          template(v-for="option in question.options")
            v-item(
              :key="option.id"
              :value="option.id"
              v-slot="{ active, toggle }"
            )
              .d-flex.flex-column.gap-8
                validation-provider(
                  name="options"
                  rules="required"
                )
                  dv-checkbox(
                    v-model="options"
                    :label="getLabel(option)"
                    :disabled="readonly"
                    :value="option.id"
                    hide-details
                    multiple
                  )

                template(v-if="option.images && option.images.length")
                  ev-image-preview(
                    :src="option.images.at(0).thumb"
                    width="200px"
                  )

      slot(
        :invalid="invalid"
        :validate="validate"
      )
</template>

<script>
import DvCheckbox from '@/packages/ui/components/inputs/DvCheckbox.vue';

// Выбор из варианта TYPE === 1
export default {
  components: {
    DvCheckbox,
  },
  name: 'QuestionOptions',
  props: {
    value: { type: Object, default: undefined },
    question: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      options: [],
    };
  },
  computed: {
    optionsWithImages() {
      return this.question.options.filter((i) => !!i.images?.length);
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val?.responseValue?.options) {
          this.options = val.responseValue.options;
        }
      },
      immediate: true,
    },
    options: {
      handler(val) {
        const { value } = this;

        this.$set(value, 'responseValue', {
          options: val,
        });
        this.$emit('input', value);
      },
      deep: true,
    },
  },
  methods: {
    getLabel(option) {
      if (option.name) return option.name;
      if (option?.images?.length) {
        const targetIdx = this.optionsWithImages.findIndex((i) => i.id === option.id);

        return `Изображение ${targetIdx + 1}`;
      }

      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox-wrap {
  position: absolute;
  top: 10px;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  padding-right: 4px;
  background: white;
  box-shadow: 0 5px 2px rgba(0, 0, 0, 0.2);
  border-radius: 9999px;
}
</style>
